import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { Field } from 'redux-form/immutable';
import { requiredRadioButton } from '../validators';
import { RadioPublicButton } from '../field-components';

function Publicity({ formName }) {
  return (
    <div className="item clearfix">
      <label className="form-label text-left col-md-3" style={{ lineHeight: '20px' }}>
        <FormattedMessage {...messages.isSecret} />
      </label>
      <Field
        labelStyle={{
          marginRight: '20px',
          marginLeft: '20px',
          lineHeight: 'inherit',
        }}
        name={`${formName}[is_public]`}
        validate={[requiredRadioButton]}
        component={RadioPublicButton}
        inputValue={1}
        label={<FormattedMessage {...messages.yes} />}
      />
      <Field
        labelStyle={{
          marginRight: '20px',
          marginLeft: '20px',
          lineHeight: 'inherit',
        }}
        name={`${formName}[is_public]`}
        validate={[requiredRadioButton]}
        component={RadioPublicButton}
        inputValue={0}
        label={<FormattedMessage {...messages.no} />}
      />
      <div className="col-md-9 text-justify" style={{ marginTop: '20px', paddingLeft: 25 }}>
        <p className="note">
          <FormattedMessage {...messages.secretInfo} />
        </p>
      </div>
    </div>
  );
}

export default Publicity;



// WEBPACK FOOTER //
// ./src/application-form/sections/publicity.js